import type { z } from "zod";

export function readSessionValue(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeSessionValue(key: string, value: string | null): boolean {
  try {
    if (value === null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

// Browser-tab recovery only. Keys are scoped to the signed-in owner and artwork;
// this never writes to the catalog or turns a local draft into saved content.
export function readSessionDraft<T>(key: string, schema: z.ZodType<T>): T | null {
  try {
    const text = sessionStorage.getItem(key);
    const result = text ? schema.safeParse(JSON.parse(text)) : null;
    return result?.success ? result.data : null;
  } catch {
    return null;
  }
}

export function writeSessionDraft(key: string, value: unknown): boolean {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
